export default __webpack_public_path__ + "static/media/CUPONS EXCLUSIVOS.ba002239.png";